// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /*--tg-theme-bg-color: var(--tg-theme-bg-color);*/
  --tg-theme-text-color: #2D3146;
  --tg-theme-hint-color: #8E8E8E;
  --tg-theme-button-color: #F3D535;
  --tg-theme-button-text-color: #2D3146;
  --accent-color: #F3D535;
  --bg-grey-color: #DEDEDE;
  --color-error: #FF3737;
  --icon-color: #2D3146 ;
}

body {
  /*--tg-theme-bg-color: var(--tg-theme-bg-color);*/
  --tg-theme-text-color: #2D3146;
  --tg-theme-hint-color: #8E8E8E;
  --tg-theme-button-color: #F3D535;
  --tg-theme-button-text-color: #2D3146;
  font-family: "Montserrat", sans-serif;
}

svg {
  fill: var(--icon-color);
}

.container {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100vh;
  width: 100%;
  max-width: 377px;
  margin: 0 auto;
  padding: 32px 19px 0px 19px;
  background: var(--tg-theme-bg-color);
  color: var(--tg-theme-text-color);
}

.darkTheme {
  /*--tg-theme-bg-color: var(--tg-theme-bg-color);*/
  --tg-theme-text-color: #ffffff;
  --tg-theme-hint-color: #8E8E8E;
  --bg-grey-color: #313131;
  --icon-color: #DEDEDE;
}

*::-webkit-scrollbar {
  width: 3px;
}

*::-webkit-scrollbar-track {
  background: transparent;
}

*::-webkit-scrollbar-thumb {
  background-color: #F3D535;
  border-radius: 20px;
}

* {
  scrollbar-width: thin;
  scrollbar-color: #F3D535 transparent;
}

a {
  color: inherit;
}

img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

select {
  width: 100%;
  padding: 6px;
  border-radius: 12px;
  color: var(--tg-theme-hint-color);
  background-color: var(--tg-theme-bg-color);
  border: 1px solid var(--tg-theme-button-color);
  text-align: center;
}

button:hover, button:active {
  transform: scale(1.1);
  opacity: 0.8;
}

#root {
  height: 100%;
}

.menuBg {
  min-height: 85px;
}

.h1 {
  display: flex;
  align-items: center;
  gap: 18px;
  margin-bottom: 28px;
  font-weight: 600;
  font-size: 30px;
  position: relative;
}
.h1 .back {
  padding: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.textCenter {
  justify-content: center;
  font-size: 25px;
}
.textCenter .back {
  padding: 10px;
  position: absolute;
  left: -10px;
  top: 0px;
  cursor: pointer;
}

.error {
  color: var(--color-error);
  font-size: 12px;
}

.mb-4 {
  margin-bottom: 16px;
}

.mb-6 {
  margin-bottom: 24px;
}

.loader {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
}`, "",{"version":3,"sources":["webpack://./src/global.scss"],"names":[],"mappings":"AACA;EACE,iDAAA;EACA,8BAAA;EACA,8BAAA;EACA,gCAAA;EACA,qCAAA;EACA,uBAAA;EACA,wBAAA;EAEA,sBAAA;EACA,sBAAA;AADF;;AAKA;EACE,iDAAA;EACA,8BAAA;EACA,8BAAA;EACA,gCAAA;EACA,qCAAA;EAEA,qCAAA;AAHF;;AAMA;EACE,uBAAA;AAHF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,2BAAA;EACA,oCAAA;EACA,iCAAA;AAHF;;AAQA;EACE,iDAAA;EACA,8BAAA;EACA,8BAAA;EACA,wBAAA;EACA,qBAAA;AALF;;AAQA;EACE,UAAA;AALF;;AAQA;EACE,uBAAA;AALF;;AAQA;EACE,yBAAA;EACA,mBAAA;AALF;;AAQA;EACE,qBAAA;EACA,oCAAA;AALF;;AAQA;EACE,cAAA;AALF;;AAQA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;AALF;;AAQA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iCAAA;EACA,0CAAA;EACA,8CAAA;EACA,kBAAA;AALF;;AASE;EAEE,qBAAA;EACA,YAAA;AAPJ;;AAWA;EACE,YAAA;AARF;;AAWA;EACE,gBAAA;AARF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AARF;AAUE;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AARJ;;AAaA;EACE,uBAAA;EACA,eAAA;AAVF;AAYE;EACE,aAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,eAAA;AAVJ;;AAeA;EACE,yBAAA;EACA,eAAA;AAZF;;AAeA;EACE,mBAAA;AAZF;;AAeA;EACE,mBAAA;AAZF;;AAeA;EACE,WAAA;EACA,YAAA;EACA,8BAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,aAAA;AAZF","sourcesContent":["\n:root {\n  /*--tg-theme-bg-color: var(--tg-theme-bg-color);*/\n  --tg-theme-text-color: #2D3146;\n  --tg-theme-hint-color: #8E8E8E;\n  --tg-theme-button-color: #F3D535;\n  --tg-theme-button-text-color: #2D3146;\n  --accent-color: #F3D535;\n  --bg-grey-color: #DEDEDE;\n  //--color-white: #ffffff;\n  --color-error: #FF3737;\n  --icon-color: #2D3146\n}\n\n\nbody {\n  /*--tg-theme-bg-color: var(--tg-theme-bg-color);*/\n  --tg-theme-text-color: #2D3146;\n  --tg-theme-hint-color: #8E8E8E;\n  --tg-theme-button-color: #F3D535;\n  --tg-theme-button-text-color: #2D3146;\n\n  font-family: 'Montserrat', sans-serif;\n}\n\nsvg {\n  fill: var(--icon-color)\n}\n\n.container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 100vh;\n  width: 100%;\n  max-width: 377px;\n  margin: 0 auto;\n  padding: 32px 19px 0px 19px;\n  background: var(--tg-theme-bg-color);\n  color: var(--tg-theme-text-color);\n\n\n}\n\n.darkTheme {\n  /*--tg-theme-bg-color: var(--tg-theme-bg-color);*/\n  --tg-theme-text-color: #ffffff;\n  --tg-theme-hint-color: #8E8E8E;\n  --bg-grey-color: #313131;\n  --icon-color: #DEDEDE;\n}\n\n*::-webkit-scrollbar {\n  width: 3px;\n}\n\n*::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n*::-webkit-scrollbar-thumb {\n  background-color: #F3D535;\n  border-radius: 20px;\n}\n\n* {\n  scrollbar-width: thin;\n  scrollbar-color: #F3D535 transparent;\n}\n\na {\n  color: inherit;\n}\n\nimg {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: cover;\n}\n\nselect {\n  width: 100%;\n  padding: 6px;\n  border-radius: 12px;\n  color: var(--tg-theme-hint-color);\n  background-color: var(--tg-theme-bg-color);\n  border: 1px solid var(--tg-theme-button-color);\n  text-align: center;\n}\n\nbutton {\n  &:hover,\n  &:active {\n    transform: scale(1.1);\n    opacity: 0.8;\n  }\n}\n\n#root {\n  height: 100%;\n}\n\n.menuBg {\n  min-height: 85px;\n}\n\n.h1 {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  margin-bottom: 28px;\n  font-weight: 600;\n  font-size: 30px;\n  position: relative;\n\n  & .back {\n    padding: 10px;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n\n  }\n}\n\n.textCenter {\n  justify-content: center;\n  font-size: 25px;\n\n  & .back {\n    padding: 10px;\n    position: absolute;\n    left: -10px;\n    top: 0px;\n    cursor: pointer;\n\n  }\n}\n\n.error {\n  color: var(--color-error);\n  font-size: 12px;\n}\n\n.mb-4 {\n  margin-bottom: 16px;\n}\n\n.mb-6 {\n  margin-bottom: 24px;\n}\n\n.loader {\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 1000;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
